import { ListItem, Skeleton, Stack } from '@mui/material';
import elements from '@legacy/assets/styles/variables/colors/global/elements.module.scss';

export const SkeletonItem = () => (
  <ListItem disablePadding>
    <Stack
      gap={0}
      sx={{
        px: 1.5,
        py: 1,
        borderBlockEnd: `1px solid ${elements.colorBorder}`,
      }}
      flex={1}
    >
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="50%" />
      <Skeleton variant="text" width="70%" />
    </Stack>
  </ListItem>
);
